<template>
    <div v-if="isReady" class="background-inbox-card-eval-vendor" v-resize="onResize">
        <v-row v-if="selectedBiz.tax_id === '0107544000094'" no-gutters
            class="standard-row font-for-header-tabs-eval-vendor d-flex justify-space-between" align="center"
            style="font-weight: 700; padding: 21px 2.6% 1% 3%;">
            <v-col cols="11" sm="11" md="auto" lg="auto">
                <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
                    <v-slide-item v-slot="{ active, toggle }" value="inbox">
                        <v-btn :input-value="active" active-class="select-header-tabs-eval-vendor"
                            class="font-for-header-tabs-eval-vendor" @click="toggle" height="52" depressed rounded text>
                            INBOX
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-if="permissionEval.includes('จัดซื้อ')" v-slot="{ active, toggle }" value="จัดซื้อ">
                        <v-btn :input-value="active" active-class="select-header-tabs-eval-vendor"
                            class="font-for-header-tabs-eval-vendor" @click="toggle" height="52" depressed rounded text>
                            จัดซื้อ
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
            <v-col v-if="permissionTabs === 'จัดซื้อ' && windowSize.x >= 1276" cols="12" sm="auto" md="9" lg="9"
                class="pt-2 display-pc-only-eval-vendor">
                <v-row no-gutters class="po-container" align="center" :justify="justifyValue">
                    <v-col cols="auto" class="po-box">
                        <p class="po-value"></p>
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getTotal()" hide-details outlined dense height="31"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown pt-2">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>                   
                    </v-col>
                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ทั้งหมด</p>
                        <p class="po-value po-value-1">{{ totalPo.total || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ที่ประเมินสำเร็จ</p>
                        <p class="po-value po-value-2">{{ totalPo.total_po_success  || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ยังไม่ได้ประเมิน</p>
                        <p class="po-value po-value-3">{{ totalPo.total_po_waiting || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">ยังไม่ได้รับสินค้าและบริการ</p>
                        <p class="po-value po-value-4">{{ totalPo.total_po_incomplete || 0 }} รายการ</p>
                    </v-col>
                </v-row>
            </v-col>
            <v-row v-if="permissionTabs === 'จัดซื้อ' && windowSize.x >= 968 && windowSize.x < 1276"
                class="pt-2 ml-2 mr-2 mb-2 display-pc-only-eval-vendor">
                <v-row no-gutters class="po-container" align="center" :justify="justifyValue">
                    <v-col cols="auto" class="po-box">
                        <p class="po-value"></p>
                            <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getTotal()" hide-details outlined dense height="31"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown pt-2">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>             
                    </v-col>
                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ทั้งหมด</p>
                        <p class="po-value po-value-1">{{ totalPo.total || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ที่ประเมินสำเร็จ</p>
                        <p class="po-value po-value-2">{{ totalPo.total_po_success  || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ยังไม่ได้ประเมิน</p>
                        <p class="po-value po-value-3">{{ totalPo.total_po_waiting || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">ยังไม่ได้รับสินค้าและบริการ</p>
                        <p class="po-value po-value-4">{{ totalPo.total_po_incomplete || 0 }} รายการ</p>
                    </v-col>
                </v-row>
            </v-row>
            <v-row v-if="permissionTabs === 'จัดซื้อ' && windowSize.x < 968"
                class="ml-2 mr-2 mb-2 display-pc-only-eval-vendor">
                <v-row  class="po-box">
                    <v-col cols="4">
                        <p class="po-value"></p>
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getTotal()" hide-details outlined dense height="31"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown pt-2"
                            >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select> 
                    </v-col>                  
                    </v-row>
                <v-row no-gutters class="po-container" align="center" :justify="justifyValue">
                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ทั้งหมด</p>
                        <p class="po-value po-value-1">{{ totalPo.total || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ที่ประเมินสำเร็จ</p>
                        <p class="po-value po-value-2">{{ totalPo.total_po_success  || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">จำนวน PO ยังไม่ได้ประเมิน</p>
                        <p class="po-value po-value-3">{{ totalPo.total_po_waiting || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="auto" class="po-box">
                        <p class="po-value">ยังไม่ได้รับสินค้าและบริการ</p>
                        <p class="po-value po-value-4">{{ totalPo.total_po_incomplete || 0 }} รายการ</p>
                    </v-col>
                </v-row>
            </v-row>
            <v-row v-if="permissionTabs === 'จัดซื้อ'" align="center"
                class="standard-row pt-4 pt-sm-7 display-mobile-only-eval-vendor">
                <v-row no-gutters class="po-container d-flex flex-column">
                    <v-col cols="12" class="po-box">
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getTotal()" hide-details outlined dense height="31"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown pt-2"
                            >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select> 
                    </v-col>

                    <v-col cols="12" class="po-box">
                        <p style="font-size: 10px; padding: 5px; color: black;">มูลค่า PO ทั้งหมด</p>
                        <p class="po-value po-value-1">{{ totalPo.total || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="12" class="po-box">
                        <p style="font-size: 10px; padding: 5px; color: black;">มูลค่า PO ประเมินสำเร็จ</p>
                        <p class="po-value po-value-2">{{ totalPo.total_po_success || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="12" class="po-box">
                        <p style="font-size: 10px; padding: 5px; color: black;">มูลค่า PO ยังไม่ได้ประเมิน</p>
                        <p class="po-value po-value-3">{{ totalPo.total_po_waiting || 0 }} รายการ</p>
                    </v-col>

                    <v-col cols="12" class="po-box">
                        <p style="font-size: 10px; padding: 5px; color: black;">ยังไม่ได้รับสินค้าและบริการ</p>
                        <p class="po-value po-value-4">{{ totalPo.total_po_incomplete || 0 }} รายการ</p>
                    </v-col>
                </v-row>
            </v-row>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" align="center"
            style="font-weight: 700; padding: 0 3.0% 0% 3.0%;">
            <v-row no-gutters class="standard-row font-theme pt-2 display-pc-only-eval-vendor" align="center">
                <v-slide-group show-arrows mandatory v-model="documentStatus">
                    <v-slide-item v-slot="{ active, toggle }" value="">
                        <v-btn :input-value="active" active-class="selected-status-tab-eval-vendor"
                            class="mb-2 document-status-tab-eval-vendor" @click="toggle" height="51" depressed rounded
                            text>
                            <v-badge inline color="#4C77B6AD" :content="myTransactionsCount.total.toString()"
                                style="font-weight: 700; font-size: 12px;" class="custom-badge-content-eval-vendor">
                                เอกสารทั้งหมด
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="success">
                        <v-btn :input-value="active" active-class="selected-status-tab-eval-vendor"
                            class="mb-2 document-status-tab-eval-vendor" @click="toggle" height="51" depressed rounded
                            text>
                            <v-badge inline color="#C5E8A9" :content="myTransactionsCount.vendor_success.toString()"
                                style="font-weight: 700; font-size: 12px;" class="custom-badge-content-eval-vendor">
                                ประเมินสำเร็จ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="waiting">
                        <v-btn :input-value="active" active-class="selected-status-tab-eval-vendor"
                            class="mb-2 document-status-tab-eval-vendor" @click="toggle" height="51" depressed rounded
                            text>
                            <v-badge inline color="#F49B9D" :content="myTransactionsCount.vendor_waiting.toString()"
                                style="font-weight: 700; font-size: 12px;" class="custom-badge-content-eval-vendor">
                                ยังไม่ประเมิน
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="incomplete">
                        <v-btn :input-value="active" active-class="selected-status-tab-eval-vendor"
                            class="mb-2 document-status-tab-eval-vendor" @click="toggle" height="51" depressed rounded
                            text>
                            <v-badge inline color="rgba(242, 231, 9, 1)" :content="myTransactionsCount.vendor_incomplete.toString()"
                                style="font-weight: 700; font-size: 12px;" class="custom-badge-content-eval-vendor">
                                ยังไม่ได้รับสินค้าและบริการ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>

                <!-- pc-only  -->

                <v-row align="center" :justify="justifyValue" no-gutters>
                    <v-col cols="3" style="border-left: 1px solid #000; height: 50px; padding-top: 10px;">
                        <v-text-field class="ml-2 py-0 font-theme border-radius-box margin-left-text-field clear-icon-margin"
                            hide-details outlined height="30" clearable v-model="keyword_search" color="black"
                            @click:clear="handleClear" @keyup.enter="checkRowsAndPageBeforeSearch"
                            @input="!keyword_search ? checkRowsAndPageBeforeSearch(keyword_search) : ''"
                            placeholder="ค้นหาข้อมูล">
                        </v-text-field>
                    </v-col>
                    <v-col cols="auto" style="border-right: 1px solid #000; height: 50px; padding-top: 10px;">
                        <v-btn style="font-weight: 700; font-size: 12px; border: 1px solid #C0C0C0;" class="ml-2 mr-2"
                            height="30" @click="checkRowsAndPageBeforeSearch">ค้นหา</v-btn>
                    </v-col>
                    <v-col cols="auto" align="center" class="font-theme ml-1 mr-1">ช่วงเวลา</v-col>
                    <v-col cols="3">
                        <v-menu v-if="windowSize.x > 779" offset-y v-model="dateMenu" min-width="auto"
                            :close-on-content-click="false" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                                <v-text-field dense hide-details clearable readonly v-on="on" color="black"
                                    :value="dateRangeShow" outlined background-color="white" height="30"
                                    @click:clear="clearDate"
                                    class="py-0 font-theme border-radius-box clear-icon-margin">
                                </v-text-field>
                            </template>
                            <v-date-picker v-show="windowSize.x > 779" color="#0B68D6" range no-title show-current
                                locale="th" v-model="dateRangeFilter"
                                @change="dateRangeFilter.length == 2 ? checkGetTransaction() : ''"
                                class="font-theme detail-date-picker-budget-inbox"
                                :max="new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"></v-date-picker>
                        </v-menu>
                    </v-col>
                        <v-btn to="/report_eval_vendor"  class="ml-2 blue-btn-eval" style="width: 112px; height: 35px;">
                        <!-- <img src="../assets/market-analysis.svg" style="width: 38px; height: 37px;"> -->
                         Report
                        </v-btn>
                </v-row>
            </v-row>
            <!-- pc-only  -->

            <!-- mobile-only  -->
            <v-row align="center" :justify="justifyValue" no-gutters class="mb-2 display-mobile-only-eval-vendor">
                <v-col cols="12" sm="12" md="6" lg="6" class="d-flex align-center justify-end mt-3">
                    <v-text-field class="py-0 font-theme border-radius-box" hide-details outlined height="36"
                        v-model="keyword_search" color="back" placeholder="ค้นหาข้อมูล" @click:clear="handleClear"
                        @keyup.enter="checkRowsAndPageBeforeSearch"
                        @input="!keyword_search ? checkRowsAndPageBeforeSearch : ''">

                    </v-text-field>
                    <v-btn class="ml-2 font-weight-bold text-body-2"
                        style="background-color: #4C77B2AD; border: 1px solid #708090;"
                        @click="checkRowsAndPageBeforeSearch">ค้นหา
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="d-flex align-center justify-start mt-3">
                    <v-menu v-if="windowSize.x <= 779" offset-y v-model="dateMenu" min-width="auto"
                        :close-on-content-click="false" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense hide-details clearable readonly v-on="on" color="black"
                                :value="dateRangeShow" outlined background-color="white" height="30"
                                @click:clear="clearDate"
                                class="py-0 font-theme border-radius-box clear-icon-margin"></v-text-field>
                        </template>
                        <v-date-picker v-show="windowSize.x <= 779" color="#0B68D6" range no-title show-current
                            locale="th" v-model="dateRangeFilter"
                            @change="dateRangeFilter.length == 2 ? checkGetTransaction() : ''"
                            class="font-theme detail-date-picker-budget-inbox"
                            :max="new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"></v-date-picker>
                    </v-menu>
                    <v-btn to="/report_eval_vendor" class="blue-btn-eval mr-2 ml-2">
                        <!-- <img src="../assets/market-analysis.svg" style="width: 38px; height: 37px;"> -->
                         Report
                    </v-btn>
                </v-col>
            </v-row>

            <!-- mobile-only  -->

            <v-row no-gutters class="standard-row display-mobile-only-eval-vendor" align="center">
                <v-col cols="12" style="font-size: 15px;" class="ml-4">
                    สถานะเอกสาร
                </v-col>
                <v-col cols="12">
                    <v-select :items="statusDocument" hide-details outlined dense height="30" item-text="status"
                        item-value="value" v-model="documentStatus" append-icon="mdi-chevron-down"
                        background-color="white" item-color="#D9D9D9" color="black"
                        :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown-eval-vender">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme"
                                    style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.status
                                    }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row mt-4 mb-7">
                <v-data-table :headers="headers" range :items="myTransactions" fixed-header @click:row="goToEvalDialog($event._id,$event.eval_status)"
                    class="elevation-0 list-data-table-eval-vendor" style="width: 100%"
                    :options.sync="optionsTransaction" :server-items-length="myTransactionsCount[documentStatusName]"
                    :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า' }"
                    mobile-breakpoint="601">
                    <template slot="no-data">
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:no-results>
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:[`footer.page-text`]="items">
                        {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                    </template>
                    <!-- <template v-slot:[`item.selected`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-checkbox v-if="item.eval_status == 'waiting'" :key="item._id" v-model="selected" :value="item._id" class="checkbox-select-all"
                                @change="handleChange(item._id)" />
                        </div>
                    </template> -->
                    <template v-slot:[`item.eval_status`]="{ item }">
                        <div v-if="item.eval_status == 'success'"><v-icon color="#74CA5F">mdi-circle-medium</v-icon>
                        </div>
                        <div v-if="item.eval_status == 'waiting'"><v-icon color="#EC9589">mdi-circle-medium</v-icon>
                        </div>
                        <div v-if="item.eval_status == 'incomplete'"><v-icon color="rgba(242, 231, 9, 1)">mdi-circle-medium</v-icon>
                        </div>
                    </template>
                </v-data-table>
            </v-row>
        </v-row>
        <EvalVendorModal/>
    </div>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import EvalVendorModal from '@/components/EvalVendorModal.vue'

export default {
    components: {
        EvalVendorModal
    },
    data: () => ({
        statusDocument: [
            { status: 'เอกสารทั้งหมด', value: '' },
            { status: 'ประเมินสำเร็จ', value: 'success' },
            { status: 'ยังไม่ได้ประเมิน', value: 'waiting' },
            { status: 'ยังไม่ได้รับสินค้าและบริการ', value: 'incomplete' },
        ],
        headers: [
            // { text: "", value: 'selected', align: 'center', sortable: false, width: '50px' },
            { text: 'PO', value: 'po_number', align: 'center', sortable: false, width: '120px' },
            { text: 'PR/SO', value: 'document_id', align: 'center', sortable: false, width: '120px' },
            { text: 'Doc Date', value: 'doc_date', align: 'center', sortable: false, width: '120px' },
            { text: 'Description', value: 'description', align: 'center', sortable: false, width: '180px' },
            { text: 'Net Price', value: 'next_price', align: 'center', sortable: false, width: '110px' },
            { text: 'VatAmount', value: 'vat_amount', align: 'center', sortable: false, width: '110px' },
            { text: 'NetAmount', value: 'net_amount', align: 'center', sortable: false, width: '120px' },
            { text: 'Status', value: 'eval_status', align: 'center', sortable: false, width: '20px' },
        ],
        permissionTabs: 'inbox',
        optionsTransaction: {
            page: 1,
            itemsPerPage: 20
        },
        dateMenu: false,
        windowSize: { x: 0, y: 0 },
        trigRowPerPage: false,
        dateRangeFilter: [],
        isChangeTab: false,
        documentStatus: '',
        callApiPending: 0,
        isReady: false,
        keyword: '',
        keyword_search: '',
        search_type: '',
        myTransactions: {},
        myTransactionsCount: {},
        documentStatusName: '',
        totalPo: {},
        filteredDropdown:[],
        year: null,
    }),
    watch: {
        "optionsTransaction.page"(newValue) {
            if (newValue != 1 || !this.isChangeTab) {
                this.getTransaction()
                this.trigRowPerPage = true
            }
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1
                this.getTransaction()
            }
        },
        "documentStatus"() {
            this.dateRangeFilter = [];
            this.keyword_search = '';
            this.keyword = '';
            this.optionsTransaction.page = 1
            this.getTransaction()
            this.isChangeTab = true
        },
        "permissionTabs"(val) {
            this.$store.commit('setMemoryTabs', val);
            if(val === 'จัดซื้อ' ){
                this.getTotal()
            }
            this.keyword_search = '';
            this.keyword = '';
            this.documentStatus = '';
            this.checkPageForGetTransaction()

        },

        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {

                EventBus.$emit('loadingState', false)
            }
        },
    },
    computed: {
        dateRangeShow() {
            this.dateRangeFilter = this.dateRangeFilter.sort()
            let formatDate = ''
            if (this.dateRangeFilter.length === 2) {
                formatDate = this.dateRangeFilter.map(element => MainFunction.shortDate(element)).join('  —  ')
            } else {
                formatDate = ''
            }
            return formatDate
        },
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
        permissionEval() {
            return this.$store.state.permissionEval
        },
        memoryTabs() {
            return this.$store.state.memoryTabs
        },
        justifyValue() {
            if (this.windowSize.x <= 1400) {
                return 'start'
            } else {
                return 'end'
            }
        },
    },
    mounted() {
        if(this.permissionEval.includes('จัดซื้อ') && this.memoryTabs == null ){
            this.permissionTabs = 'จัดซื้อ'
            this.$store.commit('setMemoryTabs', 'จัดซื้อ');
        }else{
            this.permissionTabs = this.memoryTabs
        }
        this.generateFilteredDropdown();
        this.getDefaultFilteredDropdown();
        this.onResize()
        if(this.permissionTabs === 'inbox'){
            this.getTransaction()
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        checkRowsAndPageBeforeSearch() {
            if (this.keyword === this.keyword_search) {
                return
            }
            this.keyword = (this.keyword_search || '').trim();
            this.checkPageForGetTransaction()
        },
        async getTransaction() {
            try {
                this.callApiPending++;
                const response = await this.axios({
                    baseURL: this.$api_url,
                    url: `/eval_vendor/api/v1/search_eval_vendor?limit=${this.optionsTransaction.itemsPerPage}&offset=${(this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage || 0}&keyword=${this.keyword}&inbox=${this.permissionTabs}&start_date=${this.dateRangeFilter?.sort()[0] || ''}&end_date=${this.dateRangeFilter?.sort()[1] || ''}&document_status=${this.documentStatus}`,
                    method: 'GET'
                });

                this.myTransactions = response.data.data || [];
                this.myTransactionsCount = response.data.count_status || {};
                if (this.documentStatus == "success") {
                    this.documentStatusName = "vendor_success";
                } else if (this.documentStatus == "waiting") {
                    this.documentStatusName = "vendor_waiting";
                } else if (this.documentStatus == "incomplete") {
                    this.documentStatusName = "vendor_incomplete";
                } else {
                    this.documentStatusName = "total";
                }
                if (this.myTransactions.length) {
                    $(".list-data-table-eval-vendor.v-data-table > .v-data-table__wrapper").scrollTop(0);
                }
            } catch (error) {
                console.error(error);
                this.myTransactions = [];
            } finally {
                this.callApiPending--;
                this.isChangeTab = false;
                this.trigRowPerPage = false;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        async getTotal() {
            try {
                this.callApiPending++;
                const response = await this.axios({
                    baseURL: this.$api_url,
                    url: `/eval_vendor/api/v1/total?currentQuarter=${this.filteredDropdownValue}`,
                    method: 'GET'
                });

                const totalPoNumber = response.data.data.map(e => ({
                    total_po_success: MainFunction.addComma(e.document_po_success || 0),
                    total_po_waiting: MainFunction.addComma(e.document_po_waiting || 0),
                    total_po_incomplete: MainFunction.addComma(e.document_po_incomplete || 0),
                    total: MainFunction.addComma(e.total || 0)
                }));
                this.totalPo = totalPoNumber[0] || {};
            } catch (error) {
                console.error(error);
                this.totalPo = [];
            } finally {
                this.callApiPending--;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        goToEvalDialog(idRowVendor,status) {
            const EvalDialogData = {
                id: idRowVendor,
                status: status,
                permissionTabs : this.permissionTabs
            };
            if(status === 'success' || status === 'incomplete'){
                this.$store.commit('setEvaluatedData', EvalDialogData)
                this.$router.push({ path: "/eval_vendor_detail" })
            } else {
                EventBus.$emit('toEvalDialog', EvalDialogData);
            }    
        },

        checkPageForGetTransaction() {
            if (this.optionsTransaction.page === 1) {
                this.getTransaction()
            } else {
                this.optionsTransaction.page = 1
            }
        },
        handleClear() { 
           this.keyword_search = '';
            this.keyword = '';
            this.getTransaction()
        },
        clearDate() {
            this.dateRangeFilter = [];
            this.getTransaction()
        },
        checkGetTransaction() {
            this.getTransaction()
        },
        generateFilteredDropdown() {
            this.year = new Date().getFullYear();
            this.filteredDropdown = [
                { name: `ประเมินรอบ 1/${this.year}`,value: 'Q1' },
                { name: `ประเมินรอบ 2/${this.year}`,value: 'Q2' },
                { name: `ประเมินรอบ 3/${this.year}`,value: 'Q3' },
                { name: `ประเมินรอบ 4/${this.year}`,value: 'Q4' }
            ];
        },
        getDefaultFilteredDropdown() {
            const now = new Date();
            const month = now.getMonth() + 1;
            if (month >= 1 && month <= 3) {
                this.filteredDropdownValue = 'Q1';
            } else if (month >= 4 && month <= 6) {
                this.filteredDropdownValue = 'Q2';
            } else if (month >= 7 && month <= 9) {
                this.filteredDropdownValue = 'Q3';
            } else {
                this.filteredDropdownValue = 'Q4';
            }
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        }
    }
}
</script>

<style>
.background-inbox-card-eval-vendor {
    background: #FFFFFF !important;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    border-radius: 23px;
    margin: 60px 2% 3.61% 2%;
}

.font-for-header-tabs-eval-vendor {
    font-family: 'Sarabun', sans-serif;
    font-size: calc(100% + 0.46vw) !important;
    font-weight: 700;
    letter-spacing: 2px;
    color: #8D8D8D !important;
}

.font-for-header-tabs-eval-vendor:before {
    background: transparent !important;
}

.document-status-tab-eval-vendor:before {
    background: transparent !important;
}

.select-header-tabs-eval-vendor {
    background: #73737380 !important;
    color: black !important;
}

.v-btn {
    text-transform: inherit;
}

.custom-search-dropdown-eval-vender {
    border-radius: 5px !important;
}

.custom-search-dropdown-eval-vender.v-text-field--outlined fieldset {
    border-color: none !important;
}


.custom-search-dropdown-eval-vender .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon {
    margin-top: 8px;
}

.custom-badge-content-eval-vendor {
    letter-spacing: 0 !important;
}

.clear-icon-date-picker .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
    margin-top: 8px;
}

.custom-badge-content-eval-vendor .v-badge__wrapper span {
    height: 27px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 8px;
    border-radius: 20px;
}

.custom-badge-content-eval-vendor .v-badge__wrapper {
    margin-right: 0px;
    margin-left: 10px;
}

.selected-status-tab-eval-vendor {
    background-color: #D9D9D9;
}

.list-data-table-eval-vendor .v-data-table__wrapper table .v-data-table-header tr th {
    background-color: #F1F0F0;
    height: 56px;
    box-shadow: none;
}

.list-data-table-eval-vendor.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover {
    cursor: pointer;
}

.list-data-table-eval-vendor .v-data-table__wrapper table tbody tr td {
    font-size: 12px;
    border-bottom: none !important;
}

.list-data-table-eval-vendor {
    border-radius: 10px;
    overflow-y: auto;
}

.list-data-table-eval-vendor .v-data-table__wrapper table .v-data-table-header tr th {
    background-color: #000000;
    color: #D9D9D9;
    height: 56px;
    box-shadow: none;
}

.list-data-table-eval-vendor .v-data-table-header tr {
    position: sticky !important;
    top: 0;
    z-index: 1;
    background-color: #000000 !important;
    box-shadow: none;
}

.list-data-table-eval-vendor .v-data-table-header tr::after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000000
}

.list-data-table-eval-vendor thead th:first-child {
    border-radius: 5px 0 0 0;
}

.list-data-table-eval-vendor thead th:last-child {
    border-radius: 0 5px 0 0;
}

.list-data-table-eval-vendor .v-data-table__wrapper table thead tr th {
    font-size: 12px;
}

.list-data-table-eval-vendor.v-data-table>.v-data-table__wrapper {
    height: calc(100vh - 259px);
    overflow: auto;
    scroll-behavior: smooth;
}

.list-data-table-eval-vendor.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.list-data-table-eval-vendor.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.list-data-table-eval-vendor.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #F7F6F6;
    ;
}

.list-data-table-eval-vendor>.v-data-table__wrapper>table>thead>tr>th {
    color: rgb(244, 243, 243) !important;
}

.custom-search-dropdown-eval-vender.v-select.v-input--dense .v-select__selection--comma {
    margin-left: 5px;
}

.custom-search-dropdown-eval-vender.v-text-field:not(.v-text-field--single-line) input {
    margin-left: 5px;
    line-height: 30px;
}

.custom-search-dropdown-eval-vender .v-input__control .v-input__slot .v-select__slot .v-select__selections {
    line-height: 30px;
}

@media only screen and (max-width: 600px) {

    .list-data-table-eval-vendor .v-data-table__wrapper table tbody tr td:last-child {
        border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
    }

    .list-data-table-eval-vendor .v-data-table__wrapper table tbody tr:last-child td {
        border-bottom: none !important;
    }

    .list-data-table-eval-vendor .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
        border-bottom: none !important;
    }

    .list-data-table-eval-vendor .v-data-table__empty-wrapper {
        display: flex;
        justify-content: center;
    }
}

.custom-text-field {
    max-width: 200px;
    border-radius: 8px;
    font-size: 12px;

}

.custom-text-field .v-input__control {
    border: 1px solid #A7CDEB !important;
    box-shadow: none !important;
}

.custom-text-field .v-input__control:hover {
    border-color: #5A9BD5 !important;
}

.custom-text-field .v-input__control:focus-within {
    border-color: #1E88E5 !important;
}

.po-container {
    display: flex;
    gap: 12px;
    width: 100%;
}

.po-box {
    font-family: 'Noto Sans Thai', sans-serif !important;
    text-align: center;
    padding: 10px;
    flex: 1;
}

.po-value {
    font-size: 12px;
    font-weight: 700;
    color: rgb(9, 7, 7);
    padding: 0px !important;
    border-radius: 4px;
    display: inline-block;
    width: 100%;
}

.po-value-1 {
    background-color: #4C77B6AD;
    color: white;
    font-weight: bold;
    width: 100%;
    height: 100%;
    padding: 5px !important;
    border-radius: 5px;
    display: inline-block;
}

.po-value-2 {
    background-color: #C5E8A9;
    color: white;
    font-weight: bold;
    width: 100%;
    height: 100%;
    padding: 5px !important;
    border-radius: 5px;
    display: inline-block;
}

.po-value-3 {
    background-color: #F49B9D;
    color: white;
    font-weight: bold;
    width: 100%;
    height: 100%;
    padding: 5px !important;
    border-radius: 5px;
    display: inline-block;
}

.po-value-4 {
    background-color:rgba(242, 231, 9, 1);
    color: white;
    font-weight: bold;
    width: 100%;
    height: 100%;
    padding: 5px !important;
    border-radius: 5px;
    display: inline-block;
}

.v-application .po-value-1,
.v-application .po-value-2,
.v-application .po-value-3,
.v-application .po-value-4 {
    margin-bottom: 0 !important;
}

.v-application .po-value {
    margin-bottom: 0 !important;
}

.eval-dropdown {
    margin-left: 0 !important;
    padding-left: 0px !important;
}

.eval-dropdown.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: auto !important;
    padding-left: 10px !important;
}

.eval-dropdown.v-select.v-input--dense .v-select__selection--comma {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.eval-dropdown fieldset {
    border: 1px solid #A8A8A8;
}

.eval-dropdown .v-input__icon {
    margin-top: 4px;
}

.eval-dropdown.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0px;
}

.eval-dropdown.v-select.v-input--dense .v-select__selection--comma {
    margin-left: 10px;
    margin-right: 10px;
}

.eval-dropdown.v-application--is-ltr .v-text-field .v-input__append-inner {
    margin-left: 0px !important;
    padding-left: 0px !important;
}

.eval-dropdown.v-text-field.v-input--dense .v-input__prepend-inner,
.v-text-field.v-input--dense .v-input__append-inner {
    margin-top: 0px !important;
}

.eval-dropdown .v-select__selections {
    line-height: 30px
}

.blue-btn-eval {
    background-color: #1976D2 !important;
    color: white !important;
    font-weight: 700;
}

@media only screen and (max-width:779px) {
    .display-pc-only-eval-vendor {
        display: none !important;
    }
}

@media only screen and (min-width: 780px) {
    .display-mobile-only-eval-vendor {
        display: none !important;
    }
}
</style>